// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;You are my help and my deliverer;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;O Lord, do not delay.<br> </p> </div></div>";
// Exports
module.exports = code;